import React, { useEffect, useState } from 'react';
import { CONTENT_TOP } from 'dashboard/layouts/admin/chromeGeometry';
import { Box } from '@mui/material';
import { useOutletContext } from 'react-router';
import { toast } from 'react-toastify';
import { API } from 'utilities/api';
import { LoadingOverlay, PageHeader } from 'dashboard/components/common';
import PaymentsConfig from 'dashboard/pages/brand/settings/components/PaymentsConfig';

/**
 * Payments — its own section under Brand Manager.
 *
 * Previously a card buried in brand Settings. Taking money is not a setting:
 * it has its own mode (test vs live), its own credentials, and its own
 * failure modes, and it is the step the setup checklist points at by name.
 * Someone looking for "where do I connect Stripe" should find a Payments
 * entry in the nav, not have to scroll a settings page that also holds the
 * brand's social links.
 */
export default function BrandPayments() {
  const [selectedBrand] = useOutletContext();
  const [brandData, setBrandData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!selectedBrand) return;
    setLoading(true);
    API.getBrandById({ brand_id: selectedBrand })
      .then((res) => setBrandData(res || {}))
      .catch((err) => toast.error(err?.message || 'Could not load this brand'))
      .finally(() => setLoading(false));
  }, [selectedBrand]);

  return (
    <Box sx={{ pt: CONTENT_TOP }}>
      <PageHeader
        title='Payments'
        subtitle='Run checkout on the platform Stripe while you test, then connect your own account to take live payments.'
      />
      <LoadingOverlay loading={loading} minHeight={280}>
        <PaymentsConfig brandData={brandData} />
      </LoadingOverlay>
    </Box>
  );
}
